import styled from 'styled-components';
import { beam } from '@styles/colors/themes';
import { zIndexes } from '@styles/zindex/zindex';
import { ScrollArea } from '@mantine/core';

export const Container = styled(ScrollArea.Autosize)`
  /* ZIndex */
  /* position: relative;
  z-index: ${zIndexes.indexOf('overlay-menu')}; */
  /* overflow-specific stuff */
  /* max-height:  */
  .mantine-ScrollArea-viewport {
    padding-right: 16px;
    padding-bottom: 16px;
  }
  padding-top: 16px;
  padding-left: 16px;
  transition: unset;
  width: min(90vw, calc(310px + 32px));

  /* Filter containers*/
  .FilterContainer {
    padding: 16px 0;
    & > *:not(:empty) {
      margin-top: 8px;
    }

    & > *:last-child {
      margin-bottom: 0;
    }
  }

  .FilterContainer.FilterContainer > *:first-child {
    margin-top: 0;
  }
  .OptionsDiv {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 38px;
    padding: 8px;
    &[data-position='0'] {
      margin-top: 10px; // extra.
    }
  }
`;
Container.displayName = 'Container';
export const Label = styled.h2`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  margin-bottom: 0;
`;

export const Content = styled.h2`
  color: ${beam.font.primary};
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 16px;
`;

export const Icon = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 10px;
  color: #474d66;
`;

export const Item = styled.div`
  display: flex;
  padding: 8px 0px 8px 8px;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  color: ${beam.font.primary};
  cursor: pointer;

  :hover {
    background-color: #f5f7fb;
    border-radius: 4px;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;

  margin-bottom: 16px;
`;

export const Title = styled.div`
  color: #161a30;
  font-size: 18px;
  font-weight: 600;

  &.label {
    font-size: 14px;
    font-weight: 500;
    color: #1b203a;
  }

  &.small-label {
    font-size: 12px;
    font-weight: 500;
    color: #1b203a;
    text-align: left;
  }

  &.options {
    font-size: 14px;
    font-weight: 400;
    color: #474d66;
    text-align: left;
  }

  &.date-labels {
    font-size: 12px;
    font-weight: 500;
    color: #474d66;
    text-align: left;
  }
`;

export const Row = styled.button`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 38px;
  padding: 8px;
  align-items: center;
  justify-content: space-between;
  border: 0;
  background-color: transparent;

  transition: 0.2s;

  :hover {
    border-radius: 4px;
    background-color: #f6f8ff;
  }
`;

interface IDivider {
  height: string;
}

export const Divider = styled.div<IDivider>`
  height: ${({ height }) => height};
`;

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

export const InputSearch = styled.input`
  border-radius: 8px;
  padding-left: 32px;
  padding-right: 16px;
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid #d8dae5;
  height: 36px;
  color: #474d66;
  font-size: 14px;
  width: 250px;

  &::placeholder {
    color: #8f95b2;
  }
`;

export const SearchIconContainer = styled.div`
  position: absolute;
  left: 12px;
`;

export const OptionsButton = styled.button`
  display: flex;
  flex-direction: column;
  border: 0;
  background-color: transparent;
`;

export const OptionsDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 38px;
  padding: 8px;
`;

interface ICheckbox {
  checked: boolean;
}

export const Checkbox = styled.div<ICheckbox>`
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 4px;
  border: 1px solid ${({ checked }) => (checked ? '#1371fe' : '#d8dae5')};
  background-color: ${({ checked }) => (checked ? '#1371fe' : '#fff')};

  margin-right: 8px;
`;
